import React from 'react';

import { useDateRange } from 'components';
import { DateButtonWithDropdown } from 'components';
import { TooltipWrapper } from 'components';
import { IcoGear } from 'icons/indexed-icons/IcoGear';
import { HeaderButtonContainer } from './WidgetUiHeaderButtons.elements';
import { Ellipsys } from 'icons/indexed-icons/Ellipsys';
import Open from 'icons/indexed-icons/Open';

export interface WidgetUiHeaderButtonTypesProps {
  type?: 'calendar' | 'settings' | string;
  handleToggleCustomMenu?: () => void;
  rightIconOnClick?: () => void;
  title?: string;
}

export const WidgetUiHeaderButtons = ({
  type,
  handleToggleCustomMenu,
  rightIconOnClick,
  title
}: WidgetUiHeaderButtonTypesProps): JSX.Element => {
  switch (type) {
    case 'calendar': {
      const { dateRange, setDateRange } = useDateRange();
      return (
        <TooltipWrapper Tooltip="Dates">
          <DateButtonWithDropdown {...{ dateRange, setDateRange }} iconOnly />
        </TooltipWrapper>
      );
    }

    case 'settings': {
      return (
        <TooltipWrapper Tooltip="Widget Settings">
          <HeaderButtonContainer type="button" onClick={rightIconOnClick}>
            <IcoGear />
          </HeaderButtonContainer>
        </TooltipWrapper>
      );
    }
    case 'open': {
      return (
        <TooltipWrapper Tooltip={title ? `Go to ${title}` : `Go to`}>
          <HeaderButtonContainer type="button" onClick={rightIconOnClick}>
            <Open width={14} height={14} />
          </HeaderButtonContainer>
        </TooltipWrapper>
      );
    }
    case 'menu': {
      return (
        <TooltipWrapper Tooltip="Widget Settings">
          <HeaderButtonContainer type="button" onClick={handleToggleCustomMenu}>
            <Ellipsys />
          </HeaderButtonContainer>
        </TooltipWrapper>
      );
    }

    default: {
      return <div>error: type {type} not found</div>;
    }
  }
};
